import ChangeLessonSection from './ChangeLessonSection';

export default ChangeLessonSection;
